// Shared helpers for the Account Head (DCA) budget amendment screens: the Amend popup on
// AssignCCandDCABudget and the VerifyDCABudgetAmendment inbox page (legacy AmendDCABudget /
// VerifyDCABudgetAmendView parity).
import { buildCostCenterDocUrl, buildCCBudgetDocUrl } from '../../config/s3Config';

const num = (v) => { const n = parseFloat(v); return isNaN(n) ? 0 : n; };

// Legacy AmendDCAVerification: what the DCA and the cost centre look like once this line is approved.
// Add moves budget from the CC balance into the DCA; Substract gives it back. ccBalance is the
// available CC balance (spGetBudgetAssignedCCByID already nets staged lines).
export const amendPreview = ({ type, amount, dcaBudget, dcaBalance, ccBalance }) => {
    const amt = num(amount);
    const base = { newDCABudget: num(dcaBudget), newDCABalance: num(dcaBalance), newCCBalance: num(ccBalance), error: '' };
    if (!type || amt <= 0) return base;
    if (type === 'Add') {
        if (amt > num(ccBalance)) return { ...base, error: 'Amount is greater than the Cost Centre Balance.' };
        return { newDCABudget: num(dcaBudget) + amt, newDCABalance: num(dcaBalance) + amt, newCCBalance: num(ccBalance) - amt, error: '' };
    }
    if (type === 'Substract') {
        if (amt > num(dcaBalance)) return { ...base, error: 'Amount is greater than the Account Head Balance.' };
        return { newDCABudget: num(dcaBudget) - amt, newDCABalance: num(dcaBalance) - amt, newCCBalance: num(ccBalance) + amt, error: '' };
    }
    return base;
};

// Verify page budget card, from spGetDCAAmendBudgetnew (CCBudget/CCBalance are the raw CCBudget row;
// approval takes TotalAmdValue = additions - subtractions out of the CC balance).
export const verifyBudgetSummary = (d) => {
    const ccBalance = num(d?.CCBalance);
    const totalValue = num(d?.TotalAmdValue);
    const balanceAfter = ccBalance - totalValue;
    return {
        ccBudget: num(d?.CCBudget),
        ccBalance,
        addition: num(d?.DcaAddition),
        subtraction: num(d?.DcaSubstraction),
        totalValue,
        balanceAfter,
        insufficient: balanceAfter < 0,
    };
};

// Legacy removes Return from the status list: spApproveDCABudgetAmend has no Return branch.
export const withoutReturn = (actions = []) =>
    actions.filter((a) => String(a?.type || a?.value || a?.text || '').toLowerCase() !== 'return');

// Legacy requires every amended DCA line to be ticked before Submit.
export const allLinesChecked = (checked = [], lineCount = 0) =>
    lineCount > 0 && checked.filter(Boolean).length === lineCount;

// Getccuploadocsexists row -> [label, url] links (legacy shows them for Performing CCs only).
export const ccDocLinks = (docs) => {
    const doc = Array.isArray(docs) ? docs[0] : docs;
    if (!doc || doc.contractscopeisexists !== 'Yes') return [];
    return [
        doc.contractscope && ['Scope check list approved by contracts', buildCostCenterDocUrl(doc.contractscope)],
        doc.contractpretenderBudget && ['Client Work Order confirmation with T & C approved by contracts', buildCostCenterDocUrl(doc.contractpretenderBudget)],
        doc.Approvedbudgetexecution && ['Approved budget for execution', buildCCBudgetDocUrl(doc.Approvedbudgetexecution)],
    ].filter(Boolean);
};
